/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Empty } from '../../models/empty';

export interface DeleteStoreGroup$Params {
  'Active-Tenant-Identifier': string;
  storeGroupId: string;
}

export function deleteStoreGroup(http: HttpClient, rootUrl: string, params: DeleteStoreGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<Empty>> {
  const rb = new RequestBuilder(rootUrl, deleteStoreGroup.PATH, 'delete');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeGroupId', params.storeGroupId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Empty>;
    })
  );
}

deleteStoreGroup.PATH = '/store-groups/{storeGroupId}';
